
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class EqifyMenuDropdownItem extends Vue {
  @Prop() to?: string
}
